export default "__VITE_ASSET__jj6e5Dlz__"